var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueHcaptcha',{attrs:{"sitekey":this.callback.getSiteKey()},on:{"error":_vm.handleCaptchaError,"verify":_vm.handleCaptchaVerify}})
}
var staticRenderFns = []

export { render, staticRenderFns }